import { apiRequest } from "../api/apiClient";
import { Product } from "../types/product.types";

const getProducts = async (page: number, search: string) => {
  const { data, error } = await apiRequest(
    "get",
    `/products?page=${page}&search=${encodeURIComponent(search)}`
  );

  return { data, error };
};

const productUpdate = async (product: Product) => {
  const { data, error } = await apiRequest(
    "put",
    `/products/${product._id}`,
    product
  );
  return { data, error };
};

const productDelete = async (productID: string) => {
  const { data, error } = await apiRequest("delete", `/products/${productID}`);
  return { data, error };
};

const addProduct = async (product: Omit<Product, "_id">) => {
  const { data, error } = await apiRequest("post", "/products", product);

  return { data, error };
};

export { getProducts, productUpdate, productDelete, addProduct };
